(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["italoil-500ml-aov-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = "[data-italoil-aov-offer]";
    const controllers = new Map();

    const createController = (panel) => {
      const form = document.querySelector('form[data-js-product-form="true"][data-template="true"]');
      const price = form?.querySelector(":scope > .product-price");
      const quantityControl = form?.querySelector(":scope > .product-quantity");
      const addControl = form?.querySelector(":scope > .product-add-to-cart");
      const quantityInput = form?.querySelector('input[name="quantity"]');
      const defaultAddButton = addControl?.querySelector(".add-to-cart");

      if (!form || !price || !quantityInput || !defaultAddButton) {
        return null;
      }

      price.insertAdjacentElement("afterend", panel);

      const setOriginalControlsHidden = (hidden) => {
        [quantityControl, addControl].forEach((control) => {
          control?.classList.toggle("italoil-aov-original-control-hidden", hidden);
          if (hidden) {
            control?.setAttribute("aria-hidden", "true");
          } else {
            control?.removeAttribute("aria-hidden");
          }
        });
      };

      const getOneTimeRadio = () =>
        document.querySelector('input[type="radio"][name="selling_plan"][value=""]');

      const getSelectedSellingPlan = () =>
        document.querySelector('input[type="radio"][name="selling_plan"]:checked');

      const syncPurchaseMode = () => {
        const selectedPlan = getSelectedSellingPlan();
        const subscriptionSelected = Boolean(selectedPlan && selectedPlan.value);

        panel.hidden = subscriptionSelected;
        setOriginalControlsHidden(!subscriptionSelected);
      };

      const setQuantity = (quantity) => {
        const setter = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          "value"
        )?.set;

        if (setter) {
          setter.call(quantityInput, String(quantity));
        } else {
          quantityInput.value = String(quantity);
        }

        quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      };

      const handleOfferClick = (event) => {
        const button = event.target.closest("[data-italoil-aov-quantity]");
        if (!button || button.disabled) {
          return;
        }

        const oneTimeRadio = getOneTimeRadio();
        if (oneTimeRadio && !oneTimeRadio.checked) {
          oneTimeRadio.click();
        }

        setQuantity(Number(button.dataset.italoilAovQuantity || 1));
        button.setAttribute("aria-busy", "true");

        window.requestAnimationFrame(() => {
          defaultAddButton.click();
          button.removeAttribute("aria-busy");
        });
      };

      const handlePlanChange = (event) => {
        if (event.target.matches('input[name="selling_plan"]')) {
          syncPurchaseMode();
        }
      };

      panel.addEventListener("click", handleOfferClick);
      document.addEventListener("change", handlePlanChange);

      let syncQueued = false;
      const appObserver = new MutationObserver(() => {
        if (syncQueued) {
          return;
        }

        syncQueued = true;
        window.requestAnimationFrame(() => {
          syncQueued = false;
          syncPurchaseMode();

          if (getOneTimeRadio()) {
            appObserver.disconnect();
          }
        });
      });

      if (!getOneTimeRadio()) {
        appObserver.observe(form, { childList: true, subtree: true });
      }

      syncPurchaseMode();

      return {
        destroy() {
          panel.removeEventListener("click", handleOfferClick);
          document.removeEventListener("change", handlePlanChange);
          appObserver.disconnect();
          setOriginalControlsHidden(false);
          panel.hidden = true;
        }
      };
    };

    const setup = (scope = document) => {
      const panels = scope.matches?.(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(selector) || []);

      panels.forEach((panel) => {
        if (controllers.has(panel)) {
          return;
        }

        const controller = createController(panel);
        if (controller) {
          controllers.set(panel, controller);
        }
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => setup(), { once: true });
    } else {
      setup();
    }

    document.addEventListener("shopify:section:load", (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italoil-mobile-500ml-decision-strip"] && !Shopify.designMode) return;
  try {
    
	(() => {
		const selector = "[data-italoil-mobile-decision-strip-controller]";
		const controllers = new Map();
		const productFormSelector = 'form[data-js-product-form="true"][data-template="true"]';

		const normalize = (value) =>
			String(value || "")
				.replace(/\s+/g, " ")
				.trim()
				.toUpperCase();

		const createController = (anchor) => {
			const strip = anchor.parentNode?.querySelector(
				"[data-italoil-mobile-decision-strip-content]"
			);
			const mobileQuery = window.matchMedia("(max-width: 749px)");
			const productForm = document.querySelector(productFormSelector);
			const productPrice = productForm?.querySelector(":scope > .product-price");

			if (!strip || !productForm || !productPrice) {
				return null;
			}

			const expectedTexts = [strip.dataset.sourceHarvest, strip.dataset.sourceOffer].map(
				normalize
			);
			const originalNodes = expectedTexts.map((expectedText) =>
				Array.from(productForm.querySelectorAll(":scope > .product-sales-point")).find(
					(element) => normalize(element.textContent) === expectedText
				)
			);

			if (originalNodes.some((element) => !element)) {
				return null;
			}

			const originalHiddenStates = originalNodes.map((element) =>
				element.hasAttribute("hidden")
			);
			let enhancementActive = false;

			const activate = () => {
				if (enhancementActive) {
					return;
				}

				enhancementActive = true;
				productPrice.insertAdjacentElement("afterend", strip);
				strip.classList.add("is-mounted");
				strip.removeAttribute("aria-hidden");
				originalNodes.forEach((element) => element.setAttribute("hidden", ""));
			};

			const deactivate = () => {
				if (!enhancementActive) {
					return;
				}

				enhancementActive = false;
				originalNodes.forEach((element, index) => {
					if (!originalHiddenStates[index]) {
						element.removeAttribute("hidden");
					}
				});
				strip.classList.remove("is-mounted");
				strip.setAttribute("aria-hidden", "true");
				anchor.insertAdjacentElement("afterend", strip);
			};

			const handleViewportChange = () => {
				if (mobileQuery.matches) {
					activate();
				} else {
					deactivate();
				}
			};

			mobileQuery.addEventListener("change", handleViewportChange);
			handleViewportChange();

			return {
				destroy() {
					mobileQuery.removeEventListener("change", handleViewportChange);
					deactivate();
				}
			};
		};

		const setup = (scope = document) => {
			const strips = scope.matches?.(selector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(selector) || []);

			strips.forEach((anchor) => {
				if (controllers.has(anchor)) {
					return;
				}

				const controller = createController(anchor);
				if (controller) {
					controllers.set(anchor, controller);
				}
			});
		};

		const teardown = (scope) => {
			const strips = scope.matches?.(selector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(selector) || []);

			strips.forEach((anchor) => {
				controllers.get(anchor)?.destroy();
				controllers.delete(anchor);
			});
		};

		const destroyAll = () => {
			controllers.forEach((controller) => controller.destroy());
			controllers.clear();
		};

		const containsProductForm = (scope) =>
			scope.matches?.(productFormSelector) || Boolean(scope.querySelector?.(productFormSelector));

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => setup(), { once: true });
		} else {
			setup();
		}

		document.addEventListener("shopify:section:load", (event) => {
			if (containsProductForm(event.target)) {
				window.requestAnimationFrame(() => {
					destroyAll();
					setup(document);
				});
				return;
			}

			setup(event.target);
		});

		document.addEventListener("shopify:section:unload", (event) => {
			if (containsProductForm(event.target)) {
				destroyAll();
				return;
			}

			teardown(event.target);
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italoil-mobile-500ml-first-view-atc"] && !Shopify.designMode) return;
  try {
    
	(() => {
		const selector = "[data-italoil-first-view-atc]";
		const controllers = new Map();
		const productFormSelector = 'form[data-js-product-form="true"][data-template="true"]';
		const stickyButtonSelector = ".js-sticky-add-to-cart-button";
		const widgetGuardClass = "italoil-purchase-controls-visible";

		const createController = (anchor) => {
			const mobileQuery = window.matchMedia("(max-width: 749px)");
			const productForm = document.querySelector(productFormSelector);
			const primaryButton = productForm?.querySelector(".product-add-to-cart .add-to-cart");
			const purchaseControls =
				productForm?.querySelector(".italoil-aov-offer__actions") || primaryButton;
			const stickyBar = productForm?.querySelector(".js-sticky-add-to-cart");
			const stickyButton = stickyBar?.querySelector(stickyButtonSelector);
			const stickyLabel = stickyButton?.querySelector(".product-sticky-add-to-cart__label");
			const quantityInput = productForm?.querySelector('input[name="quantity"]');
			const cartDrawer = document.querySelector(".js-cart-drawer");
			const cartNotification = document.querySelector(".js-cart-notification-modal");
			const buttonLabel = anchor.dataset.buttonLabel?.trim();
			const subscriptionButtonLabel =
				anchor.dataset.subscriptionButtonLabel?.trim() || "Add subscription";

			if (
				!productForm ||
				!primaryButton ||
				!purchaseControls ||
				!stickyBar ||
				!stickyButton ||
				!stickyLabel ||
				!quantityInput ||
				!buttonLabel
			) {
				return null;
			}

			let classObserver;
			let intersectionObserver;
			let widgetObserver;
			let labelObserver;
			let cartDrawerObserver;
			let cartNotificationObserver;
			let updateQueued = false;
			let enhancementActive = false;
			const googleWidgetOriginalStyle = new WeakMap();
			const originalLabel = stickyLabel.textContent;
			const originalAriaLabel = stickyButton.getAttribute("aria-label");

			const hasSellingPlan = () => {
				const checked = productForm.querySelector('input[name="selling_plan"]:checked');
				if (checked) {
					return Boolean(
						String(checked.value || checked.dataset.appstleRealValue || "").trim()
					);
				}

				const hidden = productForm.querySelector(
					'input[name="selling_plan"][type="hidden"]'
				);
				return Boolean(
					String(hidden?.value || hidden?.dataset.appstleRealValue || "").trim()
				);
			};

			const activeButtonLabel = () =>
				hasSellingPlan() ? subscriptionButtonLabel : buttonLabel;

			const syncStickyLabel = () => {
				const label = activeButtonLabel();
				if (stickyLabel.textContent.trim() !== label) {
					stickyLabel.textContent = label;
				}

				stickyButton.setAttribute("aria-label", label);
			};

			const restoreStickyLabel = () => {
				stickyLabel.textContent = originalLabel;

				if (originalAriaLabel === null) {
					stickyButton.removeAttribute("aria-label");
				} else {
					stickyButton.setAttribute("aria-label", originalAriaLabel);
				}
			};

			const forceSingleQuantity = () => {
				quantityInput.value = "1";
				quantityInput.setAttribute("value", "1");
				quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
				quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
			};

			const isStickyButtonTarget = (target) =>
				target instanceof Element && Boolean(target.closest(stickyButtonSelector));

			const handleStickyInteraction = (event) => {
				if (!isStickyButtonTarget(event.target)) {
					return;
				}

				forceSingleQuantity();
				syncStickyLabel();
			};

			const handleProductSubmit = (event) => {
				if (!isStickyButtonTarget(event.submitter)) {
					return;
				}

				forceSingleQuantity();
			};

			const syncGoogleMerchantWidget = (stickyIsVisible) => {
				const widget = document.getElementById("google-merchantwidget-iframe-wrapper");

				if (!widget) {
					return;
				}

				if (!googleWidgetOriginalStyle.has(widget)) {
					googleWidgetOriginalStyle.set(widget, {
						value: widget.style.getPropertyValue("bottom"),
						priority: widget.style.getPropertyPriority("bottom")
					});
				}

				if (stickyIsVisible) {
					widget.style.setProperty(
						"bottom",
						"calc(98px + env(safe-area-inset-bottom))",
						"important"
					);
					return;
				}

				const originalStyle = googleWidgetOriginalStyle.get(widget);
				if (originalStyle?.value) {
					widget.style.setProperty("bottom", originalStyle.value, originalStyle.priority);
				} else {
					widget.style.removeProperty("bottom");
				}
			};

			const purchaseControlsAreUsable = () => {
				const rectangle = purchaseControls.getBoundingClientRect();
				const styles = window.getComputedStyle(purchaseControls);
				const visibleHeight =
					Math.min(rectangle.bottom, window.innerHeight) - Math.max(rectangle.top, 0);
				const visibleWidth =
					Math.min(rectangle.right, window.innerWidth) - Math.max(rectangle.left, 0);
				const requiredHeight = Math.min(44, rectangle.height);

				return (
					visibleHeight >= requiredHeight &&
					visibleWidth > 0 &&
					styles.display !== "none" &&
					styles.visibility !== "hidden"
				);
			};

			const overlayIsOpen = (overlay) => {
				if (!overlay) {
					return false;
				}

				if (overlay.classList.contains("is-active")) {
					return true;
				}

				const styles = window.getComputedStyle(overlay);
				const rectangle = overlay.getBoundingClientRect();

				return (
					styles.display !== "none" &&
					styles.visibility !== "hidden" &&
					Number.parseFloat(styles.opacity || "1") > 0 &&
					rectangle.width > 0 &&
					rectangle.height > 0 &&
					rectangle.bottom > 0 &&
					rectangle.top < window.innerHeight
				);
			};

			const syncVisibility = () => {
				updateQueued = false;

				if (!enhancementActive) {
					return;
				}

				const purchaseControlsUsable = purchaseControlsAreUsable();
				const overlayIsVisible = overlayIsOpen(cartDrawer) || overlayIsOpen(cartNotification);
				const shouldShow =
					!purchaseControlsUsable &&
					!overlayIsVisible &&
					!primaryButton.disabled &&
					!stickyButton.disabled;

				document.body.classList.toggle(
					widgetGuardClass,
					purchaseControlsUsable || overlayIsVisible
				);
				stickyBar.classList.toggle("is-active", shouldShow);
				syncStickyLabel();
				syncGoogleMerchantWidget(shouldShow);
			};

			const queueVisibilitySync = () => {
				if (updateQueued) {
					return;
				}

				updateQueued = true;
				window.requestAnimationFrame(syncVisibility);
			};

			const handleProductFormChange = () => {
				syncStickyLabel();
				queueVisibilitySync();
			};

			const activate = () => {
				if (enhancementActive) {
					return;
				}

				enhancementActive = true;
				document.body.classList.add("italoil-first-view-atc");

				intersectionObserver = new IntersectionObserver(queueVisibilitySync, {
					threshold: [0, 0.25, 0.5, 0.75, 1]
				});
				intersectionObserver.observe(purchaseControls);

				classObserver = new MutationObserver(queueVisibilitySync);
				classObserver.observe(stickyBar, {
					attributes: true,
					attributeFilter: ["class"]
				});

				labelObserver = new MutationObserver(syncStickyLabel);
				labelObserver.observe(stickyBar, {
					childList: true,
					subtree: true,
					characterData: true
				});

				widgetObserver = new MutationObserver(queueVisibilitySync);
				widgetObserver.observe(document.body, {
					childList: true
				});

				if (cartDrawer) {
					cartDrawerObserver = new MutationObserver(queueVisibilitySync);
					cartDrawerObserver.observe(cartDrawer, {
						attributes: true,
						attributeFilter: ["class", "style", "aria-hidden"]
					});
				}

				if (cartNotification) {
					cartNotificationObserver = new MutationObserver(queueVisibilitySync);
					cartNotificationObserver.observe(cartNotification, {
						attributes: true,
						attributeFilter: ["class", "style", "aria-hidden"]
					});
				}

				stickyBar.addEventListener("pointerdown", handleStickyInteraction, true);
				stickyBar.addEventListener("click", handleStickyInteraction, true);
				productForm.addEventListener("submit", handleProductSubmit, true);
				productForm.addEventListener("change", handleProductFormChange);
				window.addEventListener("scroll", queueVisibilitySync, { passive: true });
				window.addEventListener("resize", queueVisibilitySync, { passive: true });
				stickyBar.classList.add("is-active");
				syncStickyLabel();
				syncVisibility();
			};

			const deactivate = () => {
				if (!enhancementActive) {
					return;
				}

				enhancementActive = false;
				intersectionObserver?.disconnect();
				classObserver?.disconnect();
				widgetObserver?.disconnect();
				labelObserver?.disconnect();
				cartDrawerObserver?.disconnect();
				cartNotificationObserver?.disconnect();
				stickyBar.removeEventListener("pointerdown", handleStickyInteraction, true);
				stickyBar.removeEventListener("click", handleStickyInteraction, true);
				productForm.removeEventListener("submit", handleProductSubmit, true);
				productForm.removeEventListener("change", handleProductFormChange);
				window.removeEventListener("scroll", queueVisibilitySync);
				window.removeEventListener("resize", queueVisibilitySync);
				document.body.classList.remove("italoil-first-view-atc");
				document.body.classList.remove(widgetGuardClass);
				stickyBar.classList.remove("is-active");
				restoreStickyLabel();
				syncGoogleMerchantWidget(false);

				window.requestAnimationFrame(() => {
					window.dispatchEvent(new Event("scroll"));
				});
			};

			const handleViewportChange = () => {
				if (mobileQuery.matches) {
					activate();
				} else {
					deactivate();
				}
			};

			mobileQuery.addEventListener("change", handleViewportChange);
			handleViewportChange();

			return {
				destroy() {
					mobileQuery.removeEventListener("change", handleViewportChange);
					deactivate();
				}
			};
		};

		const setup = (scope = document) => {
			const anchors = scope.matches?.(selector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(selector) || []);

			anchors.forEach((anchor) => {
				if (controllers.has(anchor)) {
					return;
				}

				const controller = createController(anchor);
				if (controller) {
					controllers.set(anchor, controller);
				}
			});
		};

		const teardown = (scope) => {
			const anchors = scope.matches?.(selector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(selector) || []);

			anchors.forEach((anchor) => {
				controllers.get(anchor)?.destroy();
				controllers.delete(anchor);
			});
		};

		const destroyAll = () => {
			controllers.forEach((controller) => controller.destroy());
			controllers.clear();
		};

		const containsProductForm = (scope) =>
			scope.matches?.(productFormSelector) || Boolean(scope.querySelector?.(productFormSelector));

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => setup(), { once: true });
		} else {
			setup();
		}

		document.addEventListener("shopify:section:load", (event) => {
			if (containsProductForm(event.target)) {
				window.requestAnimationFrame(() => {
					destroyAll();
					setup(document);
				});
				return;
			}

			setup(event.target);
		});

		document.addEventListener("shopify:section:unload", (event) => {
			if (containsProductForm(event.target)) {
				destroyAll();
				return;
			}

			teardown(event.target);
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["italoil-mobile-500ml-trust-value-panel"] && !Shopify.designMode) return;
  try {
    
	(() => {
		const controllerSelector = "[data-italoil-mobile-trust-panel-controller]";
		const productFormSelector = 'main form[data-js-product-form="true"][data-template="true"]';
		const controllers = new Map();

		const createController = (anchor) => {
			const panel = document.getElementById(anchor.dataset.panelId);
			const productForm = document.querySelector(productFormSelector);
			const price = productForm?.querySelector(":scope > .product-price");
			const targetVariantId = String(anchor.dataset.targetVariantId || "");
			const mobileQuery = window.matchMedia("(max-width: 749px)");
			const value = panel?.querySelector("[data-italoil-mobile-trust-panel-value]");

			if (!panel || !productForm || !price || !targetVariantId) return null;

			let active = false;

			const selectedVariantId = () => {
				const input = productForm.querySelector('[name="id"]');
				return String(input?.value || "");
			};

			const hasSellingPlan = () => {
				const checked = productForm.querySelector('[name="selling_plan"]:checked');
				if (checked) return Boolean(checked.value || checked.dataset.appstleRealValue);
				const input = productForm.querySelector('input[name="selling_plan"][type="hidden"]');
				return Boolean(input?.value);
			};

			const activate = () => {
				if (!active) {
					active = true;
					price.insertAdjacentElement("afterend", panel);
					panel.classList.add("is-mounted");
					panel.removeAttribute("aria-hidden");
				}
				if (value) value.hidden = hasSellingPlan();
			};

			const deactivate = () => {
				if (!active) return;
				active = false;
				panel.classList.remove("is-mounted");
				panel.setAttribute("aria-hidden", "true");
				anchor.insertAdjacentElement("afterend", panel);
			};

			const sync = () => {
				const shouldMount = mobileQuery.matches && selectedVariantId() === targetVariantId;
				if (shouldMount) activate();
				else deactivate();
			};

			mobileQuery.addEventListener("change", sync);
			productForm.addEventListener("change", sync);
			document.addEventListener("product:variant-change", sync);
			document.addEventListener("variant:change", sync);
			sync();

			return {
				destroy() {
					mobileQuery.removeEventListener("change", sync);
					productForm.removeEventListener("change", sync);
					document.removeEventListener("product:variant-change", sync);
					document.removeEventListener("variant:change", sync);
					deactivate();
				}
			};
		};

		const setup = (scope = document) => {
			const anchors = scope.matches?.(controllerSelector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(controllerSelector) || []);

			anchors.forEach((anchor) => {
				if (controllers.has(anchor)) return;
				const controller = createController(anchor);
				if (controller) controllers.set(anchor, controller);
			});
		};

		const teardown = (scope) => {
			const anchors = scope.matches?.(controllerSelector)
				? [scope]
				: Array.from(scope.querySelectorAll?.(controllerSelector) || []);

			anchors.forEach((anchor) => {
				controllers.get(anchor)?.destroy();
				controllers.delete(anchor);
			});
		};

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => setup(), { once: true });
		} else {
			setup();
		}

		document.addEventListener("shopify:section:load", (event) => setup(event.target));
		document.addEventListener("shopify:section:unload", (event) => teardown(event.target));
	})();

  } catch(e) { console.error(e); }
})();
})();
